import {
  ApiService,
} from '@/internal';

export default class SystemService extends ApiService {

  index(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/system',
      params: this.prepareParams(params),
    });
  }

  onboardData(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/system/onboard-data',
      params: this.prepareParams(params),
    });
  }

}
